import {Button, Dialog, DialogActions, DialogContent, Typography} from "@material-ui/core";
import {useCallback, useEffect, useRef, useState} from "react";
import {useEventListener} from "../../../../../../../../../Hooks/useEventListener";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";

export function convertToStringShortcut(combKeys) {
    let str = '';
    const addKeys = [
        {key: combKeys.ctrlKey, label: "Control"},
        {key: combKeys.altKey, label: "Alt"},
        {key: combKeys.shiftKey, label: "Shift"},
    ];
    const pressedAddKey = addKeys.findIndex(v => v.key === true);
    if (pressedAddKey !== -1) {
        const addKeyLabel = addKeys[pressedAddKey].label;
        str += addKeyLabel + " + "
        if (combKeys.key !== addKeyLabel) {
            str += combKeys.key
        }
        return str;
    }

    str += combKeys.key

    return str;
}

const ShortcutInput = ({onChangeEventComponent, eventIndex, events}) => {
    const rootRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [value, setValue] = useState({});
    const [savedString, setSavedString] = useState("");
    const [stringValue, setStringValue] = useState("");

    useEffect(() => {

        if (events[eventIndex] && events[eventIndex].shortcut) {
            const stringValue = convertToStringShortcut(events[eventIndex].shortcut);
            setStringValue(stringValue)
            setSavedString(stringValue)
            setValue(events[eventIndex].shortcut)
            return;
        }
        setValue({});
        setStringValue("")
        setSavedString("")
    }, [JSON.stringify(events), eventIndex])

    const keyHandler = useCallback(function keyHandler(e) {
        //..shortcut listener here

        if (!isOpen) return;


        e.stopPropagation();
        e.preventDefault();

        const combKeys = {
            ctrlKey: e.ctrlKey,
            altKey: e.altKey,
            shiftKey: e.shiftKey,
            key: e.key
        }
        const convertedToString = convertToStringShortcut(combKeys);

        if (convertedToString !== stringValue) {
            setStringValue(convertedToString)
            setValue(combKeys)
        }

    }, [stringValue, isOpen])

    function toggleDialog() {
        setIsOpen(prev => !prev)
    }

    function onApply() {
        onChangeEventComponent(value, `${eventIndex}.shortcut`)
        toggleDialog();
    }

    useEventListener('keydown', keyHandler, window)

    return (
        <>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: "flex-start",
                width: '100%',
            }}>
                <Typography variant={"body2"} color={"initial"} style={{width: '100px'}}>
                    Combination
                </Typography>
                <Button variant={'outlined'} style={{width: '50%'}} onClick={toggleDialog}>
                    <Typography variant={"body2"} color={"textSecondary"}>
                        {savedString || 'enter shortcut...'}
                    </Typography>
                </Button>
            </div>
            <Dialog open={isOpen} onClose={toggleDialog} maxWidth={"xs"} fullWidth={true}>
                <DialogTitle
                    style={{
                        padding: '8px 14px',
                        fontSize: '0.5rem'
                    }}>
                    <Typography variant={"h6"}>Shortcut combination</Typography>
                </DialogTitle>
                <Divider/>
                <DialogContent innerRef={rootRef}>
                    <div style={{padding: 20}}>
                        <Typography variant={"body2"} align={'center'}
                                    color={"textSecondary"}>
                            {stringValue || 'enter shortcut...'}
                        </Typography>
                    </div>
                </DialogContent>
                <Divider/>
                <DialogActions>
                    <Button variant={"contained"} color={'primary'} size={'small'} onClick={onApply}>
                        Apply
                    </Button>
                    <Button variant={"contained"} color={'default'} size={'small'}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ShortcutInput;